import type { FC, SVGProps } from 'react';

const EnvelopeIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.5 4C0.5 2.89543 1.39543 2 2.5 2H14.5C15.6046 2 16.5 2.89543 16.5 4V12C16.5 13.1046 15.6046 14 14.5 14H2.5C1.39543 14 0.5 13.1046 0.5 12V4ZM2.5 3C1.94772 3 1.5 3.44772 1.5 4V4.2169L8.5 8.4169L15.5 4.2169V4C15.5 3.44772 15.0523 3 14.5 3H2.5ZM15.5 5.3831L10.7919 8.20794L15.5 11.1052V5.3831ZM15.4662 12.2586L9.82583 8.7876L8.5 9.5831L7.17417 8.7876L1.53376 12.2586C1.64774 12.6855 2.03715 13 2.5 13H14.5C14.9628 13 15.3523 12.6855 15.4662 12.2586ZM1.5 11.1052L6.20808 8.20794L1.5 5.3831V11.1052Z"
        fill="#2C2543"
      />
    </svg>
  );
};

export default EnvelopeIcon;
